namespace $.$$ {

	export class $bog_vmap_app_shelf extends $.$bog_vmap_app_shelf {

		override body() {
			return (
				this.classes_showed()
					? [ this.Level(), this.Source(), this.Palette() ]
					: [ this.Level(), this.Source(), this.Parts(), this.Apps() ]
			) as readonly $mol_view[]
		}

		override source_expanded( next?: boolean ) {
			return this.$.$mol_state_session.value( 'vmap_shelf_source', next ) ?? super.source_expanded()
		}

		override parts_expanded( next?: boolean ) {
			return this.$.$mol_state_session.value( 'vmap_shelf_parts', next ) ?? super.parts_expanded()
		}

		packs() {
			return this.$.$bog_vmap_app_shelf_packs()
		}

		pack_offer( id: string ) {
			return this.packs().find( offer => offer.id === id ) ?? null
		}

		pack_rows() {
			return this.packs().map( offer => this.Pack_row( offer.id ) )
		}

		override pack_title( id: string ) {
			return this.pack_offer( id )?.title ?? ''
		}

		override pack_hint( id: string ) {
			return this.pack_offer( id )?.hint ?? ''
		}

		override pack_current( id: string ) {
			const link = this.pack_offer( id )?.link ?? ''
			if( !link ) return !this.links_parsed().pack

			return this.$.$bog_vmap_lib_slashed( link ) === this.pack_link()
		}

		@ $mol_action
		override pack_click( id: string ) {
			this.links( this.$.$bog_vmap_app_shelf_pack_swap( this.links(), this.pack_offer( id )?.link ?? '' ) )
			return null
		}

		override files( next?: readonly File[] ) {

			if( next?.length ) $mol_wire_async( this ).intake( next )

			return [] as readonly File[]
		}

		intake( files: readonly { readonly name: string, text(): Promise< string > }[] ) {

			const brought = files.map( file => ({
				name: file.name,
				text: $mol_wire_sync( file ).text(),
			}) )

			const taken = this.$.$bog_vmap_app_shelf_intake( brought )

			this.import_note( this.$.$bog_vmap_app_shelf_intake_note( taken ) )

			if( !taken.classes.length ) return

			let link = ''
			for( const one of taken.classes ) link = this.Store().import_class( one.tree, '', one.css )

			this.link_attach( link )

		}

		link_attach( link: string ) {

			if( !link ) return

			const links = this.links()
			if( links.split( /[,\s]+/ ).includes( link ) ) return

			this.links( links ? `${ links }, ${ link }` : link )

		}

		@ $mol_mem
		links_parsed() {
			return this.$.$bog_vmap_lib_links_parse( this.links() )
		}

		rejected_note() {
			return this.$.$bog_vmap_lib_links_note( this.links_parsed() )
		}

		@ $mol_mem
		app_state(): { readonly list: readonly string[], readonly error: string } {

			try {
				return {
					list: this.class_list().filter( name => !name.startsWith( '$mol_' ) ),
					error: '',
				}
			} catch( error: unknown ) {

				if( $mol_promise_like( error ) ) return $mol_fail_hidden( error )

				return {
					list: [],
					error: this.$.$bog_vmap_lib_pack_note( this.pack_tree_link(), error ),
				}
			}

		}

		pack_tree_link() {
			return this.Palette().Lib().tree_link()
		}

		app_list() {
			return this.app_state().list
		}

		app_rows() {
			return this.shown( this.app_list() ).map( name => this.Item_row( name ) )
		}

		app_error() {
			return this.app_state().error
		}

		apps_title() {
			if( this.app_error() ) return 'Приложение не отвечает'
			return this.app_list().length ? 'Объекты приложения' : 'Приложение не подключено'
		}

		shown( names: readonly string[] ) {
			return names.filter( name => this.$.$bog_vmap_app_shelf_match( this.filter(), name ) )
		}

		pack_classes(): readonly string[] {
			return this.Palette().Lib().class_list()
		}

		@ $mol_mem
		pack_state(): { readonly known: ReadonlySet< string > | null, readonly note: string } {

			if( !this.pack_link() ) return { known: null, note: '' }

			try {
				return { known: new Set( this.pack_classes() ), note: '' }
			} catch( error: unknown ) {

				if( $mol_promise_like( error ) ) return {
					known: null,
					note: 'Дерево пака деталей ещё идёт, список пока неполон',
				}

				return {
					known: null,
					note: this.$.$bog_vmap_lib_pack_note( this.pack_tree_link(), error ),
				}

			}

		}

		pack_known() {
			return this.pack_state().known
		}

		override pack_state_note() {
			return this.pack_state().note
		}

		items(): readonly $bog_vmap_app_shelf_item[] {
			return this.$.$bog_vmap_app_shelf_presets()
		}

		item_lacks( id: string ): readonly string[] {

			const known = this.pack_known()
			if( !known ) return []

			const source = this.item( id )?.source ?? ''
			if( !source ) return []

			return this.$.$bog_vmap_app_shelf_needs( source ).filter( name => !known.has( name ) )
		}

		override item_lacking( id: string ) {
			return this.item_lacks( id ).length > 0
		}

		override parts_content() {
			return [
				... this.pack_state_note() ? [ this.Pack_state() ] : [],
				... this.place_note() ? [ this.Place_note() ] : [],
				this.Items(),
			] as readonly $mol_view[]
		}

		refuse( id: string ) {

			const lacks = this.item_lacks( id )
			if( !lacks.length ) return false

			this.place_note(
				`Деталь «${ this.item_title( id ) }» не положить: в паке нет ${ lacks.join( ', ' ) }`
			)

			return true
		}

		items_shown() {
			return this.items().filter(
				item => this.$.$bog_vmap_app_shelf_match( this.filter(), item.title, item.hint )
			)
		}

		override class_offers(): readonly { readonly klass: string, readonly title: string }[] {

			const seen = new Set< string >()
			const offers = [] as { klass: string, title: string }[]

			for( const item of this.items() ) {

				const klass = this.$.$bog_vmap_app_shelf_lone( item.source )
				if( !klass || seen.has( klass ) ) continue

				seen.add( klass )
				offers.push({ klass, title: item.title })

			}

			return offers
		}

		item( id: string ): $bog_vmap_app_shelf_item | null {

			if( !id ) return null

			const own = this.items().find( item => item.id === id )
			if( own ) return own

			if( id[ 0 ] !== '$' ) return null

			return {
				id,
				title: this.$.$bog_vmap_app_shelf_short( id ),
				hint: id,
				source: this.$.$bog_vmap_app_shelf_single( id ),
			}

		}

		item_rows() {
			return this.items_shown().map( item => this.Item_row( item.id ) )
		}

		item_title( id: string ) {
			return this.item( id )?.title ?? id
		}

		item_hint( id: string ) {

			const hint = this.item( id )?.hint ?? ''
			const lacks = this.item_lacks( id )

			return lacks.length ? `${ hint } — не положить, в паке нет ${ lacks.join( ', ' ) }` : hint
		}

		override item_source( id: string ) {
			return this.item( id )?.source ?? ''
		}

		override drag_source() {
			return this.item_source( this.dragged() )
		}

		override drag_title() {
			return this.item( this.dragged() )?.title ?? ''
		}

		@ $mol_action
		item_drag( id: string, event?: PointerEvent | null ) {

			if( !event ) return
			if( this.refuse( id ) ) return

			this.place_note( '' )

			this.drag_x( event.clientX )
			this.drag_y( event.clientY )
			this.dragged( id )

		}

		@ $mol_action
		item_click( id: string, event?: Event | null ) {

			if( !this.editable() ) return
			if( this.refuse( id ) ) return

			this.place_note( '' )
			this.place( id )

		}

		override source_content() {
			const content = super.source_content()
			return this.editable() ? content : content.filter( view => view !== this.Import_field() )
		}

		override dragged( next?: string ) {
			if( next && !this.editable() ) return super.dragged()
			return super.dragged( next )
		}

	}

}
